import * as Sentry from '@sentry/browser';
import { isDevelopment } from './environment';
import { consoleLog } from './consoleLog';
import { trackException } from './Tracking';

const sentrySendError = (err: any) => {
  if (typeof err === 'string') {
    Sentry.captureException(new Error(err));
  } else {
    Sentry.captureException(err);
  }
};

export const catchError = (err: any) => {
  consoleLog(err);

  if (!isDevelopment()) {
    sentrySendError(err);

    trackException({ errorMessage: err?.message ?? err });
  }
};
export const throwError = (err: any) => {
  consoleLog(err);
  !isDevelopment() && sentrySendError(err);

  throw new Error(`${err}`);
};

export const tryCatch = ({
  onTry,
  onError,
  logging = true,
}: {
  onTry: () => void | any;
  onError?: () => void | any;
  logging?: boolean;
}) => {
  try {
    onTry();
  } catch (err) {
    logging && catchError(err);
    onError && onError();
  }
};
export const tryCatchPromise = ({
  onTry,
  onError,
  logging = true,
}: {
  onTry: () => void | any;
  onError?: () => void | any;
  logging?: boolean;
}): any => {
  try {
    return onTry();
  } catch (err) {
    logging && catchError(err);
    return onError && onError();
  }
};
